import { render, staticRenderFns } from "./StoppedOrderPage.vue?vue&type=template&id=bf165732&scoped=true&"
import script from "./StoppedOrderPage.vue?vue&type=script&lang=js&"
export * from "./StoppedOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf165732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf165732')) {
      api.createRecord('bf165732', component.options)
    } else {
      api.reload('bf165732', component.options)
    }
    module.hot.accept("./StoppedOrderPage.vue?vue&type=template&id=bf165732&scoped=true&", function () {
      api.rerender('bf165732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/Ukraine/View/StoppedOrderPage.vue"
export default component.exports